import React, { useContext } from 'react';
import { AppContext } from '../../context/listingsContext';
import StickyComponent from '../../hoc/stickyComponent';
import { MobileFilters, MachineTranslationButtonWrapper } from '../index';
import { FILTER_TYPES } from '../mobile_filters/Filter/consts';

const TouchTopBar = ({ gigs }) => {
    const { filter, isDefaultLocale } = useContext(AppContext);
    const { active, sideBar } = filter;
    const hasFilters = sideBar.length > 0;

    return (
        hasFilters &&
        <>
            <StickyComponent>
                <MobileFilters activeFilters={active}
                    filters={sideBar}
                    exportedFilterId={FILTER_TYPES.PRO}/>
            </StickyComponent>
            { !isDefaultLocale && <MachineTranslationButtonWrapper gigsListings={[gigs]} showSeparator={false}/> }
        </>

    );
};

export default TouchTopBar;
